import Routing from './objects/dashboard/routing.json';
import table from './objects/dashboard/table';
import grid from './objects/dashboard/grid';
import Starship from './objects/dashboard/svg/Starship.json';
import USMap from './objects/dashboard/svg/USMap';
import AWSRegionMap from './objects/dashboard/svg/AWSRegionMap.json';
import Cluster from './objects/dashboard/k8s/cluster.json';
import TestCluster from './objects/dashboard/k8s/testCluster.json';
import imports from './objects/dashboard/imports';
import docs from './objects/dashboard/docs';

export default [Routing, ...table, ...grid, Starship, USMap, AWSRegionMap, Cluster, TestCluster, ...imports, ...docs];
